import React from 'react';
import classNames from 'classnames';
import { Toggle } from '@dropbox/dig-components/controls';
import { Box } from '@dropbox/dig-foundations';
import { FormLabel } from '@dropbox/dig-components/form_row';
import { defineMessages, useIntl } from 'react-intl';
import { atom, useAtom } from 'jotai';
import { Text } from '@dropbox/dig-components/typography';
import { useBreakpoint } from '@dropbox/dig-components/hooks';
import { logPAPEvent } from '../../js/sign-components/common/product-analytics-pipeline';
import { PAP_Click_FormViewToggle } from '@dropbox/pap-events/sign/click_form_view_toggle';
import { useSignerAppParams } from '../signer-experience/signer-experience';
import { useBundleProps } from '../bundle-props';
import { useWhiteLabelSignerAppTextColorFixEnabled } from '../white-labeling/use-white-label-signer-app-text-color-fix';
import styles from './accessible-document-toggle.module.css';
import { useFeatureFlag } from '../context/feature-flags';

export const accessibleViewAtom = atom(false);

const messages = defineMessages({
  mobile: {
    id: 'e5ea2ac616dd4c124c236fa8e26d4b637d8410d9762af55c25085642988c547d',
    defaultMessage: 'Form view',
    description: 'Label for mobile view toggle',
  },
});

export function AccessibleDocumentToggle({ disable = false }) {
  const intl = useIntl();
  const [isAccessibleView, setAccessibleView] = useAtom(accessibleViewAtom);
  const { signatureRequestId } = useSignerAppParams();
  const { hasCustomStyles } = useBundleProps();
  const applyWhiteLabelTextColorFix =
    useWhiteLabelSignerAppTextColorFixEnabled();
  const isTextColorFixed = useFeatureFlag(
    'sign_core_2026_03_25_white_labeling_new_signer_app_text_color_fix',
  );
  const { small: displaySmall } = useBreakpoint();

  return (
    <Box
      display="flex"
      alignItems="center"
      className={classNames({
        [styles.whiteLabeledToggle]: hasCustomStyles && !isTextColorFixed,
        [styles.whiteLabeledToggleNew]: hasCustomStyles && isTextColorFixed,
      })}
    >
      <Toggle
        id="accessible-view"
        checked={isAccessibleView}
        disabled={disable}
        onChange={(evt) => {
          logPAPEvent(
            PAP_Click_FormViewToggle({
              enableFormView: evt.target.checked,
              signatureRequestId,
            }),
          );
          setAccessibleView(evt.target.checked);
        }}
      />
      <Box marginLeft="Micro Small">
        <FormLabel variant="control" htmlFor="accessible-view">
          <Text
            size={displaySmall ? 'medium' : 'small'}
            color={applyWhiteLabelTextColorFix ? 'subtle' : 'standard'}
          >
            {intl.formatMessage(messages.mobile)}
          </Text>
        </FormLabel>
      </Box>
    </Box>
  );
}
